import { MutationCache, QueryClient } from '@tanstack/react-query'
import { RECORDS_STALE_MS } from '@/lib/live-data'
import { orpc } from './client.ts'

export function createQueryClient(): QueryClient {
  const queryClient: QueryClient = new QueryClient({
    // After ANY change succeeds, search is asked again. Search reads records
    // live on the server, so this is the only way it could show something
    // stale — and doing it here, once, means no feature has to remember to.
    mutationCache: new MutationCache({
      // History too: every change writes one (docs/ACTIVITY.md).
      onSuccess: () =>
        Promise.all([
          queryClient.invalidateQueries({ queryKey: orpc.search.query.key() }),
          queryClient.invalidateQueries({ queryKey: orpc.items.history.key() }),
          queryClient.invalidateQueries({ queryKey: orpc.users.history.key() }),
          queryClient.invalidateQueries({ queryKey: orpc.recordHistory.key() }),
        ]),
    }),
    defaultOptions: {
      queries: {
        // The records tier (docs/LIVE-DATA.md): a change made in another tab,
        // by another person or by a background job shows when you come back to
        // this one or your connection returns — never only after a reload.
        // Fresh for a few seconds, so moving between screens doesn't re-ask.
        staleTime: RECORDS_STALE_MS,
        retry: 1,
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
      },
    },
  })
  return queryClient
}
